import { useState } from "react";
import { IconButton, Popover, Typography, Box, Divider } from "@mui/material";
import { Info } from "@mui/icons-material";
import moment from "moment";

const BagsInfo = ({ data }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "bags-info-popover" : undefined;

  const unit = data.po_unit || "";
  const attachUnit = (w) => `${w} ${unit}`;

  const details = [
    {
      label: "Arrival Date",
      value: data.arrival_date
        ? moment(data.arrival_date).format("ddd, MMM Do YYYY")
        : "-",
    },
    // {
    //   label: "Tare",
    //   value: "7,500 Kgs",
    // },
    {
      label: "Bags as per miller",
      value: `${data["bags as per miller"] || "-"} bags`,
    },
    {
      label: "Unloading Bags Number",
      value: `${data.unloading_bags_number ?? "-"} bags`,
    },
  ];

  return (
    <>
      <Box display="flex" alignItems="center">
        <Typography
          onClick={handleOpen}
          fontSize="0.775rem"
          sx={{
            textDecoration: "underline",
            textUnderlineOffset: "4px",
            cursor: "pointer",
          }}
        >
          {`${data["bags as per miller"] ?? "-"} bags`}
        </Typography>
        {/* <IconButton
          size="small"
          sx={{ paddingLeft: "4px" }}
        >
          <Info fontSize="inherit" />
        </IconButton> */}
      </Box>

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            minWidth: "240px",
          }}
        >   <Typography fontSize="0.8rem" fontWeight="bold" mb={1}>
                              Unloading Details
                            </Typography>
          {details.map((item, index) => (
            <Box key={index} mb={index < details.length - 1 ? 1 : 0}>
              <Typography
                fontSize="0.775rem"
                display="flex"
                justifyContent="space-between"
              >
                <span style={{ color: "#6b7280" }}>{item.label}:</span>
                <span>{item.value}</span>
              </Typography>
              {index < details.length - 1 && <Divider sx={{ my: 1 }} />}
            </Box>
          ))}
        </Box>
      </Popover>
    </>
  );
};

export default BagsInfo;
